import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { formatIsoDateTimeToTimestamp } from '@/utils/dateFormatting';

interface ScheduledClosurePanelProps {
  closureDueAt: string | null;
  isCancelling: boolean;
  onGoToExport: () => void;
  onCancel: () => void;
}

export function ScheduledClosurePanel({
  closureDueAt,
  isCancelling,
  onGoToExport,
  onCancel,
}: ScheduledClosurePanelProps) {
  const { t } = useTranslation('workspaceData');
  const dueDateLabel = closureDueAt === null ? '' : formatIsoDateTimeToTimestamp(closureDueAt);

  return (
    <div className="space-y-4">
      <div
        role="alert"
        className="flex gap-3 bg-zooerrorbg border border-zooerrorborder rounded-xl p-4"
      >
        <Icon name="AlertTriangle" className="text-lg text-zooerrortext shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-sm font-bold text-zooerrortext">{t('closure.scheduled.title')}</p>
          <p className="text-[13px] text-zooerrortext">
            {t('closure.scheduled.warning', { date: dueDateLabel })}
          </p>
          <p className="text-[13px] text-zooerrortext">{t('closure.scheduled.exportReminder')}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button variant="outlinePrimary" onClick={onGoToExport}>
          <Icon name="Download" />
          {t('closure.scheduled.goToExport')}
        </Button>
        <Button variant="outline" isLoading={isCancelling} onClick={onCancel}>
          {t('closure.scheduled.cancel')}
        </Button>
      </div>
    </div>
  );
}
